import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "title ellipsis" }

import { useProgramsStore } from '@/stores/programs';
import { useUiStore } from '@/stores/ui';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useScroll } from '@vueuse/core'
import TeamReportTable from './TeamReportTable.vue';
import TeamLimitsTable from './TeamLimitsTable.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TeamReports',
  emits: [ "toback" ],
  setup(__props, { emit }) {

const uiStore = useUiStore()


const tabs = ref(uiStore.teamReportsPage || "reports")

const programsStore = useProgramsStore()
const router = useRouter()
const program = computed(() => programsStore.programs.find(item => item.id === router.currentRoute.value.params.programId))

const currentTeam = computed({
  get() {
    return uiStore.team.id
  },
  set(teamId: string) {
    const team = program.value?.teams.find(team => team.id === teamId)
    if (!team) return
    uiStore.team = team
  }
})

const setDrawerRef = (ref: any) => {
  drawerEl.value = (ref as HTMLElement)?.parentElement || null
}
const drawerEl = ref<HTMLElement | null>(null)
const { x } = useScroll(drawerEl)

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "team-info-drawer__header",
      style: _normalizeStyle({ transform: `translateX(${_unref(x) || 0}px)` }),
      ref: (el) => { setDrawerRef(el) }
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(uiStore).team?.name) + ": Сравнение отчетов трекера", 1),
      _createVNode(_component_v_btn, {
        flat: "",
        "prepend-icon": "mdi-arrow-right",
        class: "ml-auto",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toback'))),
        style: {"opacity":"0.6"}
      }, {
        default: _withCtx(() => [
          _createTextVNode("Назад к команде")
        ]),
        _: 1
      })
    ], 4),
    _createElementVNode("div", {
      class: "px-5 mt-2 d-flex align-center",
      style: _normalizeStyle({ transform: `translateX(${_unref(x) || 0}px)` })
    }, [
      _createVNode(_component_v_tabs, {
        modelValue: tabs.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tabs).value = $event)),
        color: "primary"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, { value: "reports" }, {
            default: _withCtx(() => [
              _createTextVNode("Отчеты")
            ]),
            _: 1
          }),
          _createVNode(_component_v_tab, { value: "limits" }, {
            default: _withCtx(() => [
              _createTextVNode("Ограничения")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_select, {
        modelValue: _unref(currentTeam),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(currentTeam) ? (currentTeam).value = $event : null)),
        items: _unref(program)?.teams,
        class: "v-select-min ml-auto",
        variant: "outlined",
        label: "Команда",
        "item-value": "id",
        "item-title": "name"
      }, null, 8, ["modelValue", "items"])
    ], 4),
    (tabs.value === 'reports')
      ? (_openBlock(), _createBlock(TeamReportTable, { key: 0 }))
      : (tabs.value === 'limits')
        ? (_openBlock(), _createBlock(TeamLimitsTable, {
            key: 1,
            team: _unref(uiStore).team,
            class: "mx-6 my-2"
          }, null, 8, ["team"]))
        : _createCommentVNode("", true)
  ], 64))
}
}

})